import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "login_interface",
  "use": "login_interface-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"login_interface\"><g fill-rule=\"evenodd\"><path d=\"M15 11a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h12a1 1 0 011 1v9zM14 0H2C.897 0 0 .897 0 2v9c0 1.103.897 2 2 2h4v1.984H3.5a.5.5 0 000 1h9a.5.5 0 100-1H10V13h4c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2z\" /><path d=\"M8 6a2 2 0 10-.001-4.001A2 2 0 008 6M9 7H7a2 2 0 00-2 2v2h6V9a2 2 0 00-2-2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id